import React from "react";

import { useTranslation } from "react-i18next";

import { useEmployeeUnavailabilities } from "@hooks/useEmployeeUnavailabilities";

import MiniLoading from "@components/loader/MiniLoading";
import Button from "@components/tailwindComponents/Button";

import UnavailabilityForm from "./UnavailabilityForm";
import UnavailabilityListTable from "./UnavailabilityListTable";

function SectionUnavailability(props) {
  const { employeeId, readOnly = false } = props;
  const { t: translator } = useTranslation("pages.employés.emploi&Salary");
  const {
    list: unavailabilityList,
    isLoaded,
    isLoading,
    error,
    refresh,
    remove
  } = useEmployeeUnavailabilities(employeeId);

  console.log("unavailabilityList : ", unavailabilityList);

  return (
    <div className="arh-pb-8 arh-pl-24 arh-pr-12">
      {!readOnly && (
        <UnavailabilityForm
          key={employeeId}
          employeeId={employeeId}
          // isAvailable={isAvailable}
          refreshUnavailabilityList={refresh}
          setSuperZIndex={props.setSuperZIndex}
          unavailabilityList={unavailabilityList}
        />
      )}

      {error && (
        <div
          role="alert"
          className="arh-my-4 arh-text-xs"
        >
          <p>{translator("Une erreur est survenue")}</p>
          <Button
            variant="outlined"
            onClick={refresh}
            disabled={isLoading}
          >
            {translator("Réessayer")}
          </Button>
        </div>
      )}
      {!isLoaded && !error && employeeId ? (
        <MiniLoading />
      ) : (
        isLoaded && (
          <UnavailabilityListTable
            key={employeeId}
            unavailabilityList={unavailabilityList}
            refreshUnavailabilityList={refresh}
            removeUnavailability={remove}
            readOnly={readOnly}
            employeeId={employeeId}
          />
        )
      )}

      {/* {!readOnly && (
        <div className="arh-my-4 -arh-ml-[112px] arh-h-2 arh-w-[calc(100%+176px)] arh-bg-greyColor"></div>
      )}*/}
    </div>
  );
}

export default SectionUnavailability;
